import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/virtual',
      name: 'virtual',
      component: () => import('./views/Virtual.vue')
    },
    {
      path: '/live',
      name: 'live',
      component: () => import('./views/Live.vue')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('./views/Help.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/Users.vue')
    },
    {
      path: '/ovens',
      name: 'ovens',
      component: () => import('./views/Ovens.vue')
    },
    {
      path: '/firmware',
      name: 'firmware',
      component: () => import('./views/FirmwareUpload.vue')
    },

  ]
})
